import constants from '@/app-configs/constants'

export default [
  {
    path: '/customfields',
    name: 'custom-fields',
    component: () => import('@/views/customfields/CustomFieldsList.vue'),
    meta: {
      pageTitle: 'DEBTIA_CUSTOM_FIELDS',
      breadcrumb: [
        {
          text: 'DEBTIA_CUSTOM_FIELDS',
          active: true,
        },
      ],
      action: constants.action.permissionViewCustomVar,
      resource: constants.resource.customVariables,
    },
  },
]
